module.exports = __webpack_public_path__ + "sf-pro-text-heavy.svg?4d7dda12f83cff05d0a473bc5d78c153";